import React from "react";
import { Route, Switch } from "react-router";

import Console from "@/pages/Console";
import Result from "@/pages/Result";
import Record from "@/pages/Record";
import Help from "@/pages/Help";
import UserAgreement from "@/pages/agreement/user";
import PrivacyAgreement from "@/pages/agreement/privacy";
import AppResult from "@/pages/app-result/speedId";
import Error from "@/pages/error";

const routes = (
  <Route path="/">
    <Switch>
      <Route exact path="/" component={Console} />
      <Route path="/help" component={Help} />
      <Route path="/result" component={Result} />
      <Route path="/record" component={Record} />
      <Route path="/agreement">
        <Route path="/agreement/user" component={UserAgreement} />
        <Route path="/agreement/privacy" component={PrivacyAgreement} />
      </Route>
      <Route path="/app-result/:speedId" component={AppResult} />
      <Route component={Error} />
    </Switch>
  </Route>
);
export default routes;
